import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import Navbar from "./Navbar";
import Footer from "./Footer";
import drHelmy from "./assets/Dr helmy.jpeg";
import logo from "./assets/x_math_logo.png";
import { DemographicsSection, PhotoAlbum, SchoolMarquee } from "./MarketingSections";
import "./marketing.css";

const LandingPage = () => {
  return (
    <div className="xm-page">
      <Navbar />

      <section className="xm-hero xm-hero-plain">
        <div className="xm-hero-media" aria-hidden="true">
          <div className="xm-hero-glow" />
          <div className="xm-hero-grid" />
        </div>

        <div className="xm-hero-content xm-hero-content-center">
          <h1 className="xm-brand-mark">
            <img
              src={logo}
              alt="X-Maths"
              className="xm-hero-logo"
            />
          </h1>
          <p className="xm-headline">IGCSE Maths, taught for top grades.</p>
          <p className="xm-lede">
            Concept-first teaching from Dr Helmy Sherif — helping students worldwide
            settle outstanding results in Edexcel OL and AL Mathematics.
          </p>
          <div className="xm-cta-row">
            <Link to="/signup" className="xm-btn xm-btn-primary">
              Sign Up <FaArrowRight />
            </Link>
            <Link to="/inside" className="xm-btn xm-btn-ghost">
              Inside the class
            </Link>
            <Link to="/about" className="xm-btn xm-btn-ghost">
              Meet the founder
            </Link>
          </div>
        </div>
      </section>

      <DemographicsSection
        kicker="At a glance"
        title="Proven reach. Focused expertise."
      />

      <section className="xm-section">
        <div className="xm-wrap xm-founder-preview">
          <div className="xm-portrait xm-portrait-square">
            <img src={drHelmy} alt="Dr Helmy Sherif, Head Teacher and Founder of X-Maths" />
          </div>
          <div>
            <p className="xm-kicker">Head Teacher &amp; Founder</p>
            <h2 className="xm-section-title xm-display">Dr Helmy Sherif</h2>
            <p className="xm-section-copy">
              A leader with over 12 years of experience in IGCSE OL and AL Mathematics
              (Edexcel), teaching thousands of students. He founded X-Maths to help
              learners settle top grades in mathematics around the world.
            </p>
            <p className="xm-credential">
              Graduated from Cairo University, Faculty of Aerospace Engineering.
            </p>
            <Link to="/about" className="xm-btn xm-btn-ghost" style={{ marginTop: "1.5rem" }}>
              About X-Maths <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>

      <SchoolMarquee />

      <PhotoAlbum
        title="Learning that feels like a community"
        copy="From classroom energy to shared celebrations — X-Maths is built around students, not just content."
      />

      <section className="xm-cta-band">
        <div className="xm-wrap">
          <h2 className="xm-section-title xm-display">Ready to raise your Maths grade?</h2>
          <p className="xm-section-copy">
            Join students learning IGCSE Mathematics with clarity, structure, and
            expert guidance from X-Maths.
          </p>
          <Link to="/signup" className="xm-btn xm-btn-primary">
            Get started <FaArrowRight />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LandingPage;
